import { motion } from "framer-motion";

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.85, ease: [0.16, 1, 0.3, 1] } },
};

export const Featured = ({ properties = [] }) => {
  const featured = properties.filter((p) => p.featured).slice(0, 2);
  if (featured.length === 0) return null;

  return (
    <section data-testid="featured-section" className="relative bg-[#141A17] text-white py-24 md:py-36 overflow-hidden grain">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="max-w-2xl mb-20 md:mb-28">
          <p className="text-xs uppercase tracking-[0.3em] text-[#E8B4A0] mb-6">Featured Case Studies</p>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
            Two communities that <span className="italic text-[#E8B4A0]">define</span> the work.
          </h2>
        </div>

        <div className="space-y-28 md:space-y-40">
          {featured.map((p, i) => {
            const flip = i % 2 === 1;
            return (
              <motion.div key={p.slug} variants={fadeUp} initial="hidden" whileInView="visible"
                viewport={{ once: true, margin: "-100px" }} data-testid={`featured-item-${p.slug}`}
                className="grid md:grid-cols-12 gap-8 md:gap-14 items-center">
                <div className={`md:col-span-7 ${flip ? "md:order-2 md:col-start-6" : ""}`}>
                  <div className="relative">
                    <div className="relative overflow-hidden rounded-sm">
                      <img src={p.images[0]} alt={p.name}
                        className={`w-full ${p.slug === "virginia-dare-apartments" ? "aspect-[3/4]" : "aspect-[4/3]"} object-cover hover:scale-[1.03] transition-transform duration-[1200ms] ease-out`} />
                      {p.captions?.[0] && (
                        <span className="absolute bottom-3 right-3 bg-black/40 backdrop-blur-sm text-white/90 text-[10px] uppercase tracking-[0.2em] px-2.5 py-1 rounded-sm">
                          {p.captions[0]}
                        </span>
                      )}
                    </div>
                    {p.vintage && (
                      <div className="absolute -bottom-5 left-5 md:-left-5 bg-[#C56A4E] text-white px-5 py-3 rounded-sm max-w-[70%]">
                        <div className="font-heading text-lg leading-none">{p.vintage}</div>
                        <div className="text-[10px] uppercase tracking-[0.2em] mt-1 opacity-90">Vintage</div>
                      </div>
                    )}
                  </div>
                </div>

                <div className={`md:col-span-5 ${flip ? "md:order-1 md:col-start-1" : ""}`}>
                  <span className="font-heading text-6xl md:text-7xl text-white/10">0{i + 1}</span>
                  <h3 className="font-heading text-3xl md:text-4xl mt-2 tracking-tight">{p.name}</h3>
                  <p className="mt-2 text-xs uppercase tracking-[0.2em] text-[#E8B4A0]">
                    {p.city}, {p.state} · {p.ptype}
                  </p>
                  <p className="mt-6 text-base md:text-lg leading-relaxed text-white/70 italic font-heading">
                    “{p.story}”
                  </p>
                  {p.tags?.length > 0 && (
                    <div className="mt-6 flex flex-wrap gap-2">
                      {p.tags.map((t) => (
                        <span key={t} className="text-[11px] tracking-wide text-white/70 border border-white/20 rounded-full px-3 py-1">{t}</span>
                      ))}
                    </div>
                  )}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Featured;
